<div class="mgtp-medium" *ngIf="displayBanner && !isDashboard"></div>
<generic-banner
    [show]="displayBanner"
    [title]="title"
    [text]="text"
    [textInnerHTML]="textInnerHTML"
></generic-banner>